import type { SVGProps } from 'react';

const SvgPositionBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M18 15L21 12L18 9' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M6 9L3 12L6 15' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3 12L21 12' stroke='currentColor' strokeWidth={2} strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M9 18L12 21L15 18' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M15 6L12 3L9 6' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M12 3L12 21' stroke='currentColor' strokeWidth={2} strokeMiterlimit={10} strokeLinecap='round' />
  </svg>
);
export default SvgPositionBd;
